/* IPERTECH 2026 — CART PAGE SERVICES v4 (no-reload: AJAX section refresh) */

/* IPERTECH — sblocco richieste ESSENZIALI del carrello dal consent gate.
   Solo same-origin e solo path /cart* (add/change/update/clear/sections).
   Tracking/marketing/Google NON toccati: passano sempre dalla fetch esistente (Consentmo). */
(function(){
  try {
    var W = window, D = document;
    if(W.__iptCartFetchPatched) return;
    var passthrough = W.fetch;
    if(typeof passthrough !== 'function') return;
    var nativeFetch = null;
    try {
      var ifr = D.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.style.cssText = 'display:none!important;width:0;height:0;border:0;position:absolute;left:-9999px;top:-9999px';
      (D.body || D.documentElement).appendChild(ifr);
      nativeFetch = ifr.contentWindow && ifr.contentWindow.fetch;
    } catch(e){ nativeFetch = null; }
    if(!nativeFetch || nativeFetch === passthrough) return;
    var RE_CART = new RegExp('/cart([.](js|json))?$');
    var RE_CARTOP = new RegExp('/cart/(add|change|update|clear)([.]js)?$');
    function isEssentialCart(input){
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if(!url) return false;
        var u = new URL(url, W.location.origin);
        if(u.origin !== W.location.origin) return false;
        return RE_CART.test(u.pathname) || RE_CARTOP.test(u.pathname);
      } catch(e){ return false; }
    }
    W.fetch = function(input, init){
      try { if(isEssentialCart(input)) return nativeFetch.call(W, input, init); } catch(e){}
      return passthrough.apply(this, arguments);
    };
    W.__iptNativeFetch = nativeFetch;
    W.__iptCartFetchPatched = true;
  } catch(e){}
})();

/* IPERTECH - fix aggiornamento totale carrello Dawn.
   L'header custom non ha #cart-icon-bubble: Dawn va in errore rigenerandolo
   e non aggiorna il footer (totale). Facciamo rigenerare solo le sezioni
   presenti (articoli + footer) cosi il totale si aggiorna sempre (qty/rimozione). */
(function(){
  function patch(){
    try {
      var CI = window.customElements && customElements.get('cart-items');
      if(!CI || !CI.prototype || CI.prototype.__iptSecPatched) return;
      var orig = CI.prototype.getSectionsToRender;
      if(typeof orig !== 'function') return;
      CI.prototype.getSectionsToRender = function(){
        try {
          var list = orig.call(this) || [];
          var keep = list.filter(function(s){
            return s && document.getElementById(s.id) && (s.id === 'main-cart-items' || s.id === 'main-cart-footer');
          });
          return keep.length ? keep : list;
        } catch(e){ return orig.call(this); }
      };
      CI.prototype.__iptSecPatched = true;
    } catch(e){}
  }
  try {
    patch();
    if(window.customElements && customElements.whenDefined){
      customElements.whenDefined('cart-items').then(patch).catch(function(){});
    }
  } catch(e){}
})();

(function(){
  'use strict';
  var W = window, D = document;

  function ready(fn){ D.readyState !== 'loading' ? fn() : D.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var roots = D.querySelectorAll('[data-ipt-cart-services]');
    if(!roots.length) return;
    roots.forEach(initRoot);
  });

  function initRoot(root){
    var lastCart = null;
    var iptFetch = (window.__iptNativeFetch || window.fetch);

    function isServiceItem(it){
      return it.properties && it.properties['_ipt_service'] === 'true';
    }

    function setLoading(on){ root.classList.toggle('ipt-cs__loading', on); }

    function formatMoney(cents){
      if(cents == null) return '';
      try { return new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(cents / 100); }
      catch(ex){ return '€' + (cents / 100).toFixed(2).replace('.', ','); }
    }

    /* ---- TIERED VARIANT PARSING ---- */
    function parseTierTitle(title){
      if(!title) return null;
      var t = String(title).replace(/[.]/g, '').replace(/[ ]+/g, ' ').trim();
      var m;
      m = t.match(/fino a[ ]*[€]?[ ]*([0-9]+)/i);
      if(m) return { min: 0, max: parseInt(m[1], 10) * 100 };
      m = t.match(/da[ ]*[€]?[ ]*([0-9]+)[ ]*a[ ]*[€]?[ ]*([0-9]+)/i);
      if(m) return { min: parseInt(m[1], 10) * 100, max: parseInt(m[2], 10) * 100 };
      m = t.match(/(?:oltre|sopra|pi[uù] di)[ ]*[€]?[ ]*([0-9]+)/i);
      if(m) return { min: parseInt(m[1], 10) * 100, max: Infinity };
      return null;
    }

    function pickTierVariant(variants, totalCents){
      if(!variants || !variants.length) return null;
      var withTiers = variants.map(function(v){ return { variant: v, tier: parseTierTitle(v.title) }; })
                              .filter(function(x){ return x.tier !== null; });
      if(!withTiers.length) return variants[0];
      for(var i = 0; i < withTiers.length; i++){
        var t = withTiers[i].tier;
        if(totalCents >= t.min && totalCents <= t.max) return withTiers[i].variant;
      }
      withTiers.sort(function(a, b){ return b.tier.max - a.tier.max; });
      return withTiers[0].variant;
    }

    function applyTieredVariant(card, cart){
      var raw = card.getAttribute('data-tier-variants');
      if(!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch(ex){ return; }
      if(!variants || !variants.length) return;
      var totalCents = 0;
      (cart.items || []).forEach(function(it){
        if(!isServiceItem(it)) totalCents += (it.final_line_price || 0);
      });
      var picked = pickTierVariant(variants, totalCents);
      if(!picked) return;
      var priceCents = Math.round(parseFloat(picked.price) * 100);
      card.setAttribute('data-variant-id', picked.id);
      card.setAttribute('data-price-cents', priceCents);
      var priceEl = card.querySelector('.ipt-cs__svc-price');
      if(priceEl) priceEl.textContent = '+ ' + formatMoney(priceCents);
    }

    /* ---- FILTRO Dawn cart items: nasconde i line item service dalla lista standard Dawn ---- */
    function hideDawnServiceItems(cart){
      var svcVariantIds = {};
      (cart.items || []).forEach(function(it){
        if(isServiceItem(it)) svcVariantIds[it.variant_id] = true;
      });
      /* Dawn usa cart-items con tr/li/div che hanno data-variant-id o variant_id nei dataset / link */
      var candidates = D.querySelectorAll('cart-items [data-variant-id], cart-items tr, cart-items li, .cart-items [data-variant-id], .cart-items tr, .cart-items li');
      candidates.forEach(function(el){
        var vid = parseInt(el.getAttribute('data-variant-id') || el.dataset.variantId || '0', 10);
        if(!vid){
          /* Cerca link al variant nel sub-DOM */
          var link = el.querySelector('a[href*=variant]');
          if(link){
            var m = link.getAttribute('href').match(/variant=([0-9]+)/);
            if(m) vid = parseInt(m[1], 10);
          }
        }
        if(vid && svcVariantIds[vid]){
          el.style.display = 'none';
        }
      });
    }

    function fetchCart(){
      return iptFetch(W.routes && W.routes.cart_url ? W.routes.cart_url + '.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r){ return r.json(); });
    }

    /* ---- NO-RELOAD: refresh AJAX delle sezioni carrello (lista Dawn + totale) ---- */
    function getInnerHTML(html, selector){
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(selector);
        return el ? el.innerHTML : null;
      } catch(ex){ return null; }
    }

    function updateInner(hostId, html, selector){
      if(!html) return;
      var host = D.getElementById(hostId);
      if(!host) return;
      var target = host.querySelector(selector);
      var inner = getInnerHTML(html, selector);
      if(target && inner != null) target.innerHTML = inner;
    }

    function refreshCartUI(){
      var base = (W.routes && W.routes.cart_url) ? W.routes.cart_url : '/cart';
      var itemsEl = D.getElementById('main-cart-items');
      var footerEl = D.getElementById('main-cart-footer');
      var itemsId = itemsEl ? itemsEl.getAttribute('data-id') : null;
      var footerId = footerEl ? footerEl.getAttribute('data-id') : null;
      var req = [];
      if(itemsId) req.push(itemsId);
      if(footerId) req.push(footerId);
      req.push('cart-icon-bubble');
      return iptFetch(base + '?sections=' + req.join(','))
        .then(function(r){ return r.json(); })
        .then(function(data){
          if(itemsId) updateInner('main-cart-items', data[itemsId], '.js-contents');
          if(footerId) updateInner('main-cart-footer', data[footerId], '.js-contents');
          var bubble = D.getElementById('cart-icon-bubble');
          if(bubble && data['cart-icon-bubble']){
            var bi = getInnerHTML(data['cart-icon-bubble'], '.shopify-section');
            if(bi != null) bubble.innerHTML = bi;
          }
        })
        .then(function(){ return fetchCart(); })
        .then(function(cart){
          syncCards(cart);
          try { W.dispatchEvent(new CustomEvent('ipt-cart:updated', { detail: { cart: cart } })); } catch(ex){}
          setLoading(false);
        })
        .catch(function(err){ setLoading(false); console.warn('[ipt-cs] refresh error', err); });
    }

    /* ---- AUTO-SWAP tiered variant ---- */
    var swappingNow = false;
    function autoSwapTieredVariants(cart){
      if(swappingNow) return;
      var swaps = [];
      root.querySelectorAll('[data-ipt-cs-svc]').forEach(function(card){
        if(card.getAttribute('data-tiered') !== 'true') return;
        var raw = card.getAttribute('data-tier-variants');
        if(!raw) return;
        var variants;
        try { variants = JSON.parse(raw); } catch(ex){ return; }
        var tieredIds = variants.map(function(v){ return v.id; });
        var currentItem = (cart.items || []).find(function(it){
          return isServiceItem(it) && tieredIds.indexOf(it.variant_id) !== -1;
        });
        if(!currentItem) return;
        var totalCents = 0;
        (cart.items || []).forEach(function(it){
          if(!isServiceItem(it)) totalCents += (it.final_line_price || 0);
        });
        var picked = pickTierVariant(variants, totalCents);
        if(!picked || picked.id === currentItem.variant_id) return;
        swaps.push({ oldKey: currentItem.key, newVariantId: picked.id });
      });
      if(!swaps.length) return;
      swappingNow = true;
      var promise = Promise.resolve();
      swaps.forEach(function(s){
        promise = promise
          .then(function(){
            return iptFetch(W.routes && W.routes.cart_change_url ? W.routes.cart_change_url + '.js' : '/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: s.oldKey, quantity: 0 })
            });
          })
          .then(function(r){ return r.json(); })
          .then(function(){
            return iptFetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: s.newVariantId, quantity: 1, properties: { _ipt_service: 'true' } }] })
            });
          })
          .then(function(r){ return r.json(); });
      });
      promise.then(function(){ swappingNow = false; refreshCartUI(); })
             .catch(function(err){ swappingNow = false; console.warn('[ipt-cs] tier swap error', err); });
    }

    /* ---- DELTA ANIMATION ---- */
    function showDelta(card, cents, isAdding){
      var float = D.createElement('div');
      float.className = 'ipt-cs__delta-float' + (isAdding ? '' : ' is-negative');
      float.textContent = (isAdding ? '+ ' : '− ') + formatMoney(Math.abs(cents));
      card.style.position = 'relative';
      card.appendChild(float);
      setTimeout(function(){ float.remove(); }, 900);
    }

    function syncCards(cart){
      lastCart = cart;
      root.querySelectorAll('[data-ipt-cs-svc]').forEach(function(card){
        if(card.getAttribute('data-tiered') === 'true'){
          applyTieredVariant(card, cart);
        }
        var vid = parseInt(card.getAttribute('data-variant-id'), 10);
        var tieredIds = [];
        if(card.getAttribute('data-tiered') === 'true'){
          try { tieredIds = JSON.parse(card.getAttribute('data-tier-variants') || '[]').map(function(v){ return v.id; }); } catch(ex){}
        }
        var inCart = (cart.items || []).some(function(it){
          if(!isServiceItem(it)) return false;
          if(tieredIds.length && tieredIds.indexOf(it.variant_id) !== -1) return true;
          return it.variant_id === vid;
        });
        var check = card.querySelector('[data-ipt-cs-svc-check]');
        if(check) check.checked = inCart;
        card.classList.toggle('is-active', inCart);
      });
      hideDawnServiceItems(cart);
      autoSwapTieredVariants(cart);
    }

    function addService(variantId, card){
      card.classList.add('is-active');
      setLoading(true);
      var priceCents = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
      showDelta(card, priceCents, true);
      iptFetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _ipt_service: 'true' } }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        /* NO RELOAD: aggiorna via AJAX le sezioni Dawn (totale + lista) */
        refreshCartUI();
      })
      .catch(function(err){
        setLoading(false);
        card.classList.remove('is-active');
        var check = card.querySelector('[data-ipt-cs-svc-check]');
        if(check) check.checked = false;
        console.warn('[ipt-cs] service add error', err);
      });
    }

    function removeService(variantId, card){
      if(!lastCart) return;
      var allowedIds = [variantId];
      if(card && card.getAttribute('data-tiered') === 'true'){
        try {
          var tv = JSON.parse(card.getAttribute('data-tier-variants') || '[]');
          allowedIds = tv.map(function(v){ return v.id; });
        } catch(ex){}
      }
      var svcItem = null;
      for(var i = 0; i < (lastCart.items || []).length; i++){
        var it = lastCart.items[i];
        if(allowedIds.indexOf(it.variant_id) !== -1 && isServiceItem(it)){ svcItem = it; break; }
      }
      if(!svcItem) return;
      card.classList.remove('is-active');
      setLoading(true);
      showDelta(card, (svcItem.final_line_price || svcItem.price || 0), false);
      iptFetch(W.routes && W.routes.cart_change_url ? W.routes.cart_change_url + '.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: svcItem.key, quantity: 0 })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        /* NO RELOAD */
        refreshCartUI();
      })
      .catch(function(err){
        setLoading(false);
        card.classList.add('is-active');
        var check = card.querySelector('[data-ipt-cs-svc-check]');
        if(check) check.checked = true;
        console.warn('[ipt-cs] service remove error', err);
      });
    }

    function bindEvents(){
      root.querySelectorAll('[data-ipt-cs-svc]').forEach(function(card){
        var check = card.querySelector('[data-ipt-cs-svc-check]');
        if(!check) return;

        card.addEventListener('click', function(e){
          if(e.target === check || e.target.closest('label')) return;
          check.checked = !check.checked;
          check.dispatchEvent(new Event('change'));
        });

        check.addEventListener('change', function(){
          var vid = parseInt(card.getAttribute('data-variant-id'), 10);
          if(!vid) return;
          if(check.checked){
            addService(vid, card);
          } else {
            removeService(vid, card);
          }
        });
      });
    }

    /* Sync con cart attuale e sottoscrivi a ipt-cart:updated dal drawer */
    fetchCart().then(syncCards).catch(function(){});
    W.addEventListener('ipt-cart:updated', function(e){
      if(e && e.detail && e.detail.cart) syncCards(e.detail.cart);
    });

    bindEvents();
  }
})();
